import styled from 'styled-components';

export const StyledDay = styled.div`
    ${({ theme, $isSelected, isCurrentMonth, isOnline, $big }) => `
        border: 1px solid ${$isSelected ? theme.palette.common.green4 : theme.palette.common.gray5};
        border-radius: 14px;

        aspect-ratio: ${$big ? '1 / 1' : 'auto'};

        padding: 5px;

        display: flex;
        flex-direction: column;
        row-gap: 3px;
        cursor: ${isCurrentMonth ? 'pointer' : 'not-allowed'};
        justify-content: space-between;

        opacity: ${isCurrentMonth ? 1 : 0.5};

        background-color: ${isOnline ? theme.palette.common.green8 : 'transparent'};
        
    `}
`;

export const StyledDayTextContainer = styled.div`
    ${({ theme, isToday }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    border-radius: 50px;
    background-color: ${isToday ? theme.palette.common.gray2 : 'transparent'};
    `}
`;

export const StyledDayEventContainer = styled.div`
    ${({ theme, $backgroundColor, $big }) => `
    background-color: ${$backgroundColor ? theme.palette.common[$backgroundColor] : 'transparent'};
    border-radius: 8px;
    display: flex;
    justify-content:  ${$big ? 'space-between' : 'flex-end'};
    padding: 0 8px 0 4px;
    align-items: center;
    height: 14px;
    `}
`;

export const StyledDialog = styled.div`
    ${({ theme }) => `
    background: ${theme.palette.common.backdrop};
    backdrop-filter: blur(2px);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    `}
`;

export const StyledInputCard = styled.div`
    ${({ theme }) => `
    border: 1px solid ${theme.palette.common.gray6};
    border-radius: 16px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    `}
`;

export const StyledTimeBox = styled.div`
    ${({ theme, $borderColor }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${
        $borderColor ? theme.palette.common[$borderColor] : theme.palette.common.gray6
    };
    padding: 3px 15px;
    border-radius: 16px;
    `}
`;
